import { render } from "./PriceUpdateModal.vue?vue&type=template&id=2856c4b2&scoped=true"
import script from "./PriceUpdateModal.vue?vue&type=script&lang=js"
export * from "./PriceUpdateModal.vue?vue&type=script&lang=js"

import "./PriceUpdateModal.vue?vue&type=style&index=0&id=2856c4b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2856c4b2"]])

export default __exports__